import {
  getPayCourse,
  getPublicCourse,
  getSvipLessonPage,
  getMyCourse,
  getCatalog,
  getStudent,
  getCourseware,
  watchLive,
  getLive,
  lookVideo,
  getTemplate,
  getJoinCode
} from "@/services/course";
import { formatArr } from "@/utils/util";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    courseList: [],
    myCourseList: [],
    myTotalCourse: 0,
    catalogList: [],
    catalogTotal: 0,
    studentList: [],
    studentTotal: 0,
    studentStr: "",
    wareList: [],
    wareTotal: 0,
    liveData: {},
    templateList: [],
    code: ""
  },
  actions: {
    async getPayCourseList({ dispatch, commit }, payload) {
      const params = {
        startTime: payload[0].date,
        endTime: payload[payload.length - 1].date
      };
      const list = (await getPayCourse({ params })) || [];
      commit("UPDATE_VALUE_STATES", {
        key: "courseList",
        data: formatArr(payload, list)
      });
    },
    async getPublicCourseList({ dispatch, commit }, payload) {
      const params = {
        startTime: payload[0].date,
        endTime: payload[payload.length - 1].date
      };
      const list = (await getPublicCourse({ params })) || [];
      commit("UPDATE_VALUE_STATES", {
        key: "courseList",
        data: formatArr(payload, list)
      });
    },
    async getSvipCourseList({ dispatch, commit }, payload) {
      const params = {
        lessonBeginTimeStart: moment(payload[0].date).format("yyyy-MM-DD HH:mm:ss"),
        lessonBeginTimeEnd: moment(payload[payload.length - 1].date).format(
          "yyyy-MM-DD HH:mm:ss"
        ),
        status: 1
      };
      const res = await getSvipLessonPage(params);
      const list = res && res.list || []
      commit("UPDATE_VALUE_STATES", {
        key: "courseList",
        data: formatArr(payload, list)
      });
    },
    async getMyCourseList({ dispatch, commit }, payload) {
      const res = (await getMyCourse({ params: { ...payload } })) || {};
      commit("UPDATE_VALUE_STATES", { key: "myCourseList", data: res.list });
      commit("UPDATE_VALUE_STATES", { key: "myTotalCourse", data: res.total });
    },
    async getCatalogList({ dispatch, commit }, payload) {
      const res = (await getCatalog({ params: { ...payload } })) || {};
      const obj = res.list[0].treeMap;
      let arr = [];
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          arr.push(obj[key]);
        }
      }
      let data = [];
      arr.forEach(item => {
        item.map(it => {
          data.push(it);
        });
      });
      commit("UPDATE_VALUE_STATES", { key: "catalogList", data });
      commit("UPDATE_VALUE_STATES", { key: "catalogTotal", data: res.total });
    },
    async getStudentList({ dispatch, commit }, payload) {
      const res = (await getStudent({ params: { ...payload } })) || {};
      commit("UPDATE_VALUE_STATES", { key: "studentList", data: res.list });
      commit("UPDATE_VALUE_STATES", { key: "studentTotal", data: res.total });
      commit("UPDATE_VALUE_STATES", { key: "studentStr", data: res.totalStr });
    },
    async getCoursewareList({ dispatch, commit }, payload) {
      const res = (await getCourseware({ params: { ...payload } })) || {};
      commit("UPDATE_VALUE_STATES", { key: "wareList", data: res.list });
      commit("UPDATE_VALUE_STATES", { key: "wareTotal", data: res.total });
    },
    async toWatchLive({ dispatch, commit }, payload) {
      const res = (await watchLive({ params: { ...payload } })) || {};
      window.open(res.liveUrl, "_blank");
    },
    async getLiveData({ dispatch, commit }, payload) {
      const res = (await getLive({ params: { ...payload } })) || {};
      commit("UPDATE_VALUE_STATES", { key: "liveData", data: res });
    },
    async toLookVideo({ dispatch, commit }, payload) {
      const res = (await lookVideo({ params: { ...payload } })) || {};
      window.open(res, "_blank");
    },
    async getTemplateList({ dispatch, commit }, payload) {
      const res = (await getTemplate({ ...payload })) || {};
      commit("UPDATE_VALUE_STATES", { key: "templateList", data: res.list });
    },
    async getBJYJoinCode({ dispatch, commit }, payload) {
      const res = (await getJoinCode({ ...payload })) || {};
      commit("UPDATE_VALUE_STATES", { key: "code", data: res.code });
    }
  },
  mutations: {
    UPDATE_VALUE_STATES(state, payload) {
      const { key, data } = payload;
      state[key] = data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/course.js